/**
 * Bazı kayıtlarda WMS sipariş adresi JSON string olarak (e-ticaret entegrasyonundan ham haliyle)
 * geliyor. Bu yardımcı, ham adres alanını insan okur formatta kısa bir metne çevirir.
 *
 * Kabul ettiği yapı (PascalCase / camelCase tolere edilir):
 *   { Title?, Type?, FirstName?, LastName?, Phone?, Address?, AddressLine?, Neighborhood?, District?, City?, PostalCode? }
 *
 * Eğer girdi geçerli JSON değilse, ham metni olduğu gibi döndürür.
 */
export const formatCustomerAddress = (rawAddress: string | null | undefined): string => {
  const raw = String(rawAddress || '').trim();
  if (!raw) return '-';

  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') {
      const city = parsed.City || parsed.city;
      const district = parsed.District || parsed.district;
      const neighborhood = parsed.Neighborhood || parsed.neighborhood;
      const addressLine =
        parsed.Address || parsed.address || parsed.AddressLine || parsed.addressLine;
      const postal = parsed.PostalCode || parsed.postalCode;
      const firstName = parsed.FirstName || parsed.firstName;
      const lastName = parsed.LastName || parsed.lastName;
      const phone = parsed.Phone || parsed.phone;

      const segments = [
        [firstName, lastName].filter(Boolean).join(' ').trim(),
        phone ? `Tel: ${phone}` : '',
        neighborhood,
        district,
        city,
        postal ? `(${postal})` : '',
        addressLine,
      ].filter(Boolean);

      if (segments.length > 0) return segments.join(', ');
    }
  } catch {
    // JSON degil, ham metni dondur.
  }

  return raw;
};

export default formatCustomerAddress;
